import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { onlyNumbers } from '@brazilian-utils/brazilian-utils';
import { Card, Stack, Text, TextField } from '@hub-la/design-system';
import { useGetBusiness } from '@hub-la/fe-get-user';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { DocumentType } from '../../domain/enums/bank-account.js';

const PixKeyForm = () => {
  var _a, _b, _c, _d;
  const {
    values
  } = useFormikContext();
  const {
    data: account
  } = useGetBusiness();
  const {
    t
  } = useTranslation();
  const documentNumber = (_b = (_a = values.businessOwner) === null || _a === void 0 ? void 0 : _a.documentNumber) !== null && _b !== void 0 ? _b : (_c = account === null || account === void 0 ? void 0 : account.businessOwner) === null || _c === void 0 ? void 0 : _c.documentNumber;
  const isCNPJ = ((_d = values.businessOwner) === null || _d === void 0 ? void 0 : _d.documentType) === DocumentType.CNPJ || onlyNumbers(documentNumber).length > 11;
  return jsx(Card, Object.assign({
    hasHover: false,
    variant: "filled"
  }, {
    children: jsxs(Stack, Object.assign({
      direction: "column",
      spacing: 4
    }, {
      children: [jsxs(Stack, Object.assign({
        direction: "column",
        spacing: 2
      }, {
        children: [jsx(Text, {
          children: t('accountVerification.form.pixKey.title')
        }), jsx(Text, Object.assign({
          variant: "body2"
        }, {
          children: t('accountVerification.form.pixKey.subtitle')
        }))]
      })), jsx(NumberFormat, {
        id: "businessOwner.documentNumber",
        disabled: true,
        label: isCNPJ ? 'CNPJ' : 'CPF',
        format: isCNPJ ? '##.###.###/####-##' : '###.###.###-#####',
        size: "normal",
        type: "tel" // numbers only
        ,
        value: documentNumber,
        customInput: TextField,
        fullWidth: true
      })]
    }))
  }));
};

export { PixKeyForm };
